import { Component, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { QuestionBase } from '@mmx/shared'

@Component({
  selector: 'mmx-if-questions',
  templateUrl: './if-questions.component.html',
  styleUrls: ['./if-questions.component.scss'],
  standalone: false,
})
export class IfQuestionsComponent {
  @Input() question: QuestionBase<any>
  @Input() form: UntypedFormGroup
  @Input() active: boolean
}
